// extracted by mini-css-extract-plugin
export default {"container":"orderdetail_container__MICgX","CardTop":"orderdetail_CardTop__9Dmim","Card":"orderdetail_Card__FhlOy","cardbtn":"orderdetail_cardbtn__0Gobw"};